import React, {Component} from 'react';
import {Input} from '@material-ui/core';

class NumberInput extends Component {

    render() {

        return (
            <Input
                {...this.props}
                onChange={(event) => {
                    const regex = /^[0-9]+$/; // regex for only number
                    if (event.target.value.match(regex) || event.target.value === '') this.props.onChange(event);
                }}
            />
        );
    }
}

export default NumberInput;



// WEBPACK FOOTER //
// ./src/components/NumberInput.js